import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'page-borclu-cari-hesaplar-report',
  templateUrl: 'borclu-cari-hesaplar-report.html',
})
export class BorcluCariHesaplarReportPage {
  BorcluListesi=[];
  BorcluListesi2=[];
  aranan="";
  take:number=5000;
  constructor(public navCtrl: NavController, 
    public bllOrtak:BllOrtak,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.cariAra(null);
    
  }
  cariAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);

    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BorcluCariHesaplar","", false).then(a => {
     
      var sonuc = <any>a;
      this.BorcluListesi = sonuc.SonucObject;
   
      this.BorcluListesi2=this.BorcluListesi.filter(a=>a.Bakiyesi!=0);
      console.log("sonlistes",this.BorcluListesi2);
  
 
    })
  }
  cariler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/borclu-cari-hesaplar-report/borclu-cari-hesaplar-report.ts